import { render, staticRenderFns } from "./financeSection.vue?vue&type=template&id=136678bc&scoped=true"
import script from "./financeSection.vue?vue&type=script&lang=js"
export * from "./financeSection.vue?vue&type=script&lang=js"
import style0 from "./financeSection.vue?vue&type=style&index=0&id=136678bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136678bc",
  null
  
)

export default component.exports